import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start flex-column" }
const _hoisted_2 = { class: "container mt-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_6 = { class: "col-sm-12" }
const _hoisted_7 = {
  key: 0,
  class: "card"
}
const _hoisted_8 = {
  key: 0,
  class: "row p-3 m-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "Rating", -1)
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "float-right" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "float-right" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = { class: "float-right" }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = { class: "float-right" }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "float-right" }
const _hoisted_21 = { class: "col-sm-4 text-left" }
const _hoisted_22 = {
  key: 1,
  class: "row p-3 m-2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "改善建議和示範", -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 2,
  class: "row p-3 m-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "Unique Vocabulary Items", -1)
const _hoisted_27 = { class: "col-sm-2" }
const _hoisted_28 = { class: "col-sm-6 h5 text-left" }
const _hoisted_29 = {
  key: 3,
  class: "row p-3 m-2"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "Vocab Items Related To Topic", -1)
const _hoisted_31 = { class: "col-sm-2" }
const _hoisted_32 = { class: "col-sm-6 h5 text-left" }
const _hoisted_33 = {
  key: 4,
  class: "row p-3 m-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "Filler Words", -1)
const _hoisted_35 = { class: "col-sm-2" }
const _hoisted_36 = { class: "col-sm-6 h5 text-left" }
const _hoisted_37 = {
  key: 5,
  class: "row p-3 m-2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "Sentiment", -1)
const _hoisted_39 = { class: "col-sm-2 emoticon-wrapper" }
const _hoisted_40 = { class: "col-sm-6 text-left" }
const _hoisted_41 = {
  key: 6,
  class: "row p-3 m-2"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "h6 col-sm-2 text-right" }, "家長的小提示", -1)
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  class: "d-flex align-items-end flex-column",
  style: {"height":"10vh"}
}
const _hoisted_45 = { class: "col-sm-4" }
const _hoisted_46 = ["value"]

import { ref, onMounted } from "vue";
  import { getAuth, signOut } from "firebase/auth";
  import { db } from "@/firebase";
  import { doc, getDoc } from 'firebase/firestore';
  import { useRoute, useRouter } from "vue-router";
  import { Pie } from 'vue-chartjs';
  import {
      Chart as ChartJS,
      CategoryScale,
      LinearScale,
      ArcElement,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
  } from 'chart.js';
  import EmoticonOutlineIcon from 'vue-material-design-icons/EmoticonOutline.vue';
  import EmoticonHappyOutlineIcon from 'vue-material-design-icons/EmoticonHappyOutline.vue';
  import EmoticonNeutralOutlineIcon from 'vue-material-design-icons/EmoticonNeutralOutline.vue';
  import EmoticonSadOutlineIcon from 'vue-material-design-icons/EmoticonSadOutline.vue';
  import EmoticonFrownOutlineIcon from 'vue-material-design-icons/EmoticonFrownOutline.vue';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveSessionResultsView',
  setup(__props) {

  ChartJS.register(
      CategoryScale,
      LinearScale,
      ArcElement,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
  )
  
  let auth;
  const errorMessage = ref();
  const studentData = ref({});
  const router = useRouter();
  const analysisJson = ref();
  const overallScore = ref(0);
  const childSpeakingTime = ref(null)
  const childSpeakingTimeOptions = ref({
          plugins: {
            title: {
              display: true,
              text: "學生積極參與比率",
              font: {
                size: 24,
                family: 'Helvetica Neue'
              }
            },
          },
          responsive: true
  })

 async function getStudentByStudentNo(studentNo: string) {
    const docRef = doc(db, "students", studentNo);
    const docSnap = await getDoc(docRef);
    return docSnap;
 }

  async function getResultByAnalysisId(analysisId: string) {
    const docRef = doc(db, "results", analysisId);
    const docSnap = await getDoc(docRef);
    return docSnap;
  }  

  function logout() {
    signOut(auth).then(
      ()=>{
        router.push('/signin');
      }
    )
  }
  
  onMounted(async ()=>{
    auth = getAuth();
    const route = useRoute();
    console.log('Loading analysis: ' + route.query.analysisId)
  
    if (route.query.studentcode && route.query.analysisId) {
        const studentMatch = await getStudentByStudentNo(route.query.studentcode)

        if (!studentMatch.exists()) {
            console.log('could not find student:' + route.query.studentcode)
        }
        else {
            studentData.value = studentMatch.data();
            const resultDoc = await getResultByAnalysisId(route.query.analysisId);
            if (!resultDoc.exists()) {
                console.log('could not find analysis:' + route.query.analysisId);
            }
            else {
                analysisJson.value = resultDoc.data().result;
                overallScore.value = Math.round((analysisJson.value.主題相關性評級 + analysisJson.value.內容組織評級 + analysisJson.value.情感表達評級 +  analysisJson.value.詞彙豐富度評級) / 4);

                // childSpeakingTime.value = {
                //     labels: ['學生參與', '學生不參與'],
                //     datasets: [{
                //         data: [timers['child'].value / timeElapsed.value, 1-(timers['child'].value / timeElapsed.value)],
                //         backgroundColor: ['#41B883', '#E46651']
                //     }]
                // }
            }
        }
    }
    else {
        errorMessage.value = "Student code and/or analysis ID missing"
    }

  })
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: logout,
          class: "btn"
        }, "Logout")
      ]),
      _createElementVNode("div", _hoisted_2, [
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, _toDisplayString(studentData.value.studentName), 1),
        _createElementVNode("div", _hoisted_4, [
          (childSpeakingTime.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(Pie), {
                  id: "child-speaking-time-pie",
                  options: childSpeakingTimeOptions.value,
                  data: childSpeakingTime.value
                }, null, 8, ["options", "data"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (analysisJson.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (analysisJson.value.整體說話評分)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, [
                            _createTextVNode("主題相關性評級: "),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(analysisJson.value.主題相關性評級) + " / 10", 1)
                          ]),
                          _createElementVNode("p", _hoisted_13, [
                            _createTextVNode("內容組織評級: "),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(analysisJson.value.內容組織評級) + " / 10", 1)
                          ]),
                          _createElementVNode("p", _hoisted_15, [
                            _createTextVNode("情感表達評級: "),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(analysisJson.value.情感表達評級) + " / 10", 1)
                          ]),
                          _createElementVNode("p", _hoisted_17, [
                            _createTextVNode("詞彙豐富度評級: "),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(analysisJson.value.詞彙豐富度評級) + " / 10", 1)
                          ]),
                          _createElementVNode("p", _hoisted_19, [
                            _createTextVNode("整體評級: "),
                            _createElementVNode("b", _hoisted_20, _toDisplayString(overallScore.value) + " / 10", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(analysisJson.value.整體說話評分解釋), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.改善建議和示範)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", {
                          style: {"white-space":"pre-wrap"},
                          class: "col-sm-8 text-left",
                          innerHTML: analysisJson.value.改善建議和示範
                        }, null, 8, _hoisted_24)
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.unique_vocabulary_items)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(analysisJson.value.unique_vocabulary_items.length), 1),
                        _createElementVNode("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.unique_vocabulary_items, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge rounded-pill bg-light text-dark",
                              key: index
                            }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.vocabulary_items_related_to_topic)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, _toDisplayString(analysisJson.value.vocabulary_items_related_to_topic.length), 1),
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.vocabulary_items_related_to_topic, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge rounded-pill bg-light text-dark",
                              key: index
                            }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.filler_words)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, _toDisplayString(analysisJson.value.filler_words.length), 1),
                        _createElementVNode("div", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisJson.value.filler_words, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge rounded-pill bg-light text-dark",
                              key: index
                            }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.整體情緒評級)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          (analysisJson.value.整體情緒評級 > 4)
                            ? (_openBlock(), _createBlock(EmoticonOutlineIcon, {
                                key: 0,
                                size: "3em"
                              }))
                            : _createCommentVNode("", true),
                          (analysisJson.value.整體情緒評級 == 4)
                            ? (_openBlock(), _createBlock(EmoticonHappyOutlineIcon, {
                                key: 1,
                                size: "3em"
                              }))
                            : _createCommentVNode("", true),
                          (analysisJson.value.整體情緒評級 == 3)
                            ? (_openBlock(), _createBlock(EmoticonNeutralOutlineIcon, {
                                key: 2,
                                size: "3em"
                              }))
                            : _createCommentVNode("", true),
                          (analysisJson.value.整體情緒評級 == 2)
                            ? (_openBlock(), _createBlock(EmoticonSadOutlineIcon, {
                                key: 3,
                                size: "3em"
                              }))
                            : _createCommentVNode("", true),
                          (analysisJson.value.整體情緒評級 < 2)
                            ? (_openBlock(), _createBlock(EmoticonFrownOutlineIcon, {
                                key: 4,
                                size: "3em"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(analysisJson.value.整體情緒評級解釋), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (analysisJson.value.家長的小提示)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", {
                          style: {"white-space":"pre-wrap"},
                          class: "col-sm-6 text-left",
                          innerHTML: analysisJson.value.家長的小提示
                        }, null, 8, _hoisted_43)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMic) = $event)),
          class: "form-control"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.microphones, (microphone) => {
            return (_openBlock(), _createElementBlock("option", {
              key: microphone.deviceId,
              value: microphone
            }, _toDisplayString(microphone.label), 9, _hoisted_46))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedMic]
        ])
      ])
    ])
  ], 64))
}
}

})